/* @flow */
import Reaction from 'entities/Reaction';
import Collection from 'lib/Collection';

export default class Reactions extends Collection {
  parse(response: Object) {
    return response.map(reaction => Reaction.fromJSON(reaction));
  }
}



// WEBPACK FOOTER //
// ./src/collections/Reactions.js